<div class="air-details-container">
    <div class="header">Air Compliance Details
    </div>
    <div *ngIf="!isLoading">
        <div class="section-title">TLR Tag Number: {{tagNumber}}
        </div>
        <div class="partioned-table">
            <div class="row">
                <div class="cell label">Repair Type
                </div>
                <div class="cell value">{{complianceData['repair_type_name']}}
                </div>
            </div>
            <div class="row">
                <div class="cell label">Division
                </div>
                <div class="cell value">{{complianceData.division_name}}
                </div>
            </div>
            <div class="row">
                <div class="cell label">Section
                </div>
                <div class="cell value">{{complianceData.section_name}}
                </div>
            </div>
            <div class="row">
                <div class="cell label">Plant
                </div>
                <div class="cell value">{{complianceData.plant_name}}
                </div>
            </div>
            <div class="row">
                <div class="cell label">TLR Tag No.
                </div>
                <div class="cell value">{{tagNumber}}
                </div>
            </div>
            <div class="row">
                <div class="cell label">Rule 1173
                </div>
                <div class="cell value">{{complianceData.rule_1173}}
                </div>
            </div>
            <div class="row">
                <div class="cell label">Leaking From
                </div>
                <div class="cell value">{{complianceData.leaking_name}}
                </div>
            </div>
            <div class="row">
                <div class="cell label">Asset Number
                </div>
                <div class="cell value">{{complianceData.mx_assetnum}}
                </div>
            </div>
            <div class="row">
                <div class="cell label">Operating PSI
                </div>
                <div class="cell value">{{complianceData.operating_PSI}}
                </div>
            </div>
            <div class="row">
                <div class="cell label">Operating Temp
                </div>
                <div class="cell value">{{complianceData.operating_temperature}}
                </div>
            </div>
            <div class="row">
                <div class="cell label">Vapor/Liquid
                </div>
                <div class="cell value">{{complianceData.material_state_name}}
                </div>
            </div>
            <div class="row">
                <div class="cell label">Service(s)
                </div>
                <div class="cell value" [innerHTML]="services">{{services}}
                </div>
            </div>
            <div class="row">
                <div class="cell label">AIR User ID Owner
                </div>
                <div class="cell value">
                    <input pInputText [ngClass]="{'disabled-input': !airUserIdEditable}" [readonly]="!airUserIdEditable"
                        [(ngModel)]="airComplianceForm.airEmail" />
                </div>
            </div>
            <div class="row">
                <div class="cell label">Cost Center
                </div>
                <div class="cell value">
                    <input pInputText [(ngModel)]="airComplianceForm.costCenter" maxlength="3" />
                </div>
            </div>
            <div class="row">
                <div class="cell label">LDAR Blue Tag Number
                </div>
                <div class="cell value">
                    <input pInputText [(ngModel)]="airComplianceForm.ldarBlueTag" />
                </div>
            </div>
            <div class="row">                <div class="cell label">Last Inspection Date
                </div>
                <div class="cell value">
                    <input pInputText [(ngModel)]="airComplianceForm.lastInspectionDate" 
                           [ngClass]="{'ng-invalid': isInvalidDate}" />
                    <small class="error-message" *ngIf="isInvalidDate">Invalid Date format</small>
                </div>
            </div>
            <div class="row">
                <div class="cell label">TLR Repair Info
                </div>
                <div class="cell value">
                    <input pInputText [(ngModel)]="airComplianceForm.repairInfo" />
                </div>
            </div>
            <div class="row">
                <div class="cell label">PNID
                </div>
                <div class="cell value">
                    <input pInputText [(ngModel)]="airComplianceForm.pnid" />
                </div>
            </div>
            <div class="row">
                <div class="cell label">AIR Comments
                </div>
                <div class="cell value">
                    <textarea pInputTextarea [(ngModel)]="airComplianceForm.comments" rows="4"></textarea>
                </div>
            </div>

        </div>
        <div class="button-row">
            <button pButton class="btn-primary" (click)="saveDetails()">Save</button>
        </div>
    </div>